import { lumi } from './lumi'

const APP_CREATOR_ID = 'app-4s'
const APP_CREATOR_EMAIL = 'sistema@app4s.local'

type AppendOnlyRecord = {
  _id?: string
  id?: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
  creator?: string
  creatorEmail?: string
  [key: string]: unknown
}

type LumiEntity = {
  create: (data: Record<string, unknown>) => Promise<unknown>
}

function nowISO() {
  return new Date().toISOString()
}

function removeUndefinedFields<T extends Record<string, unknown>>(payload: T): T {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined),
  ) as T
}

function getEntity(entityName: string) {
  return (lumi.entities as Record<string, LumiEntity>)[entityName]
}

function stripInternalFields(record: AppendOnlyRecord) {
  const payload = { ...record }
  delete payload._id
  return payload
}

export async function persistAppendOnlyVersion(entityName: string, record: AppendOnlyRecord) {
  const entity = getEntity(entityName)
  const timestamp = nowISO()

  await entity.create(removeUndefinedFields({
    ...stripInternalFields(record),
    id: String(record.id ?? record._id ?? ''),
    creator: record.creator ?? APP_CREATOR_ID,
    creatorEmail: record.creatorEmail ?? APP_CREATOR_EMAIL,
    createdAt: record.createdAt ?? timestamp,
    updatedAt: timestamp,
  }))
}

export async function persistDeletedVersion(entityName: string, record: AppendOnlyRecord) {
  const entity = getEntity(entityName)
  const timestamp = nowISO()

  await entity.create(removeUndefinedFields({
    ...stripInternalFields(record),
    id: String(record.id ?? record._id ?? ''),
    creator: record.creator ?? APP_CREATOR_ID,
    creatorEmail: record.creatorEmail ?? APP_CREATOR_EMAIL,
    createdAt: record.createdAt ?? timestamp,
    updatedAt: timestamp,
    deletedAt: timestamp,
  }))
}

export async function persistDeletedVersions(entityName: string, records: AppendOnlyRecord[]) {
  await Promise.all(records.map(record => persistDeletedVersion(entityName, record)))
}
